exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".training-info[data-v-08788aee]{background:#f8f9fa;padding:15px;border-radius:8px;border-left:4px solid #007bff;box-shadow:2px 2px 8px rgba(0,0,0,.1);font-family:Arial,sans-serif;max-width:400px}.training-title[data-v-08788aee]{font-size:18px;font-weight:700;color:#333;margin-bottom:5px}.training-body[data-v-08788aee]{font-size:16px;color:#555;margin-bottom:10px}.training-dates[data-v-08788aee]{display:flex;flex-direction:column;font-size:14px;color:#666;margin-top:5px}.training-dates span[data-v-08788aee]{padding:3px 0}", ""]);

// exports
